import styled from "styled-components";
import { breakpoints } from "styles";

export const KelasLiveDownloadBlockContainer = styled.section`
  padding: 40px 0;
`;

export const KelasLiveDownloadBlockTitle = styled.h2`
  position: relative;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  line-height: 1.3;
  max-width: 650px;
  margin: 0 auto;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  }
`;

export const KelasLiveDownloadBlockTitleHighlight = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
`;
export const KelasLiveDownloadBlockItemsWrapper = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${breakpoints.tablet} {
    flex-direction: row;
  }
`;

export const KelasLiveDownloadBlockItem = styled.li`
  flex-grow: 1;
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.colors.neutral[200]};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const KelasLiveDownloadBlockItemImageWrapper = styled.figure`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(
      360deg,
      ${({ theme }) => theme.colors.white} 0%,
      transparent 50%,
      transparent 100%
    );
  }
`;

export const KelasLiveDownloadBlockItemDesc = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  line-height: 1.3;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const KelasLiveDownloadBlockAppsContainer = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
`;

export const KelasLiveDownloadBlockVisitLink = styled.div`
  display: block;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.neutral[100]};
  background: ${({ theme }) => theme.colors.neutral[50]};
  padding: 12px;
  width: 90%;
  border-radius: 6px;

  @media ${breakpoints.laptop} {
    display: none;
  }
`;

export const KelasLiveDownloadBlockDownloadAppButton = styled.div`
  display: block;
  @media ${breakpoints.laptop} {
    display: none;
  }
`;

export const KelasLiveDownloadBlockDownloadButtonWrapper = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: block;
  }
`;

export const KelasLiveDownloadBlockAppImageWrapper = styled.a`
  display: block;
  position: relative;
  width: 140px;
  height: 40px;
  transition: 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;

export const KelasLiveDownloadBlockTitleStarLeftWrapper = styled.span`
  position: absolute;
  bottom: 5px;
  left: -5px;
  color: ${({ theme }) => theme.colors.brand[600]};
  width: 14px;
  height: 14px;

  @media ${breakpoints.tablet} {
    width: 28px;
    height: 28px;
  }
`;

export const KelasLiveDownloadBlockTitleStarRightLargeWrapper = styled.span`
  position: absolute;
  top: -30px;
  right: 0px;
  color: ${({ theme }) => theme.colors.brand[500]};
  width: 20px;
  height: 20px;

  @media ${breakpoints.tablet} {
    right: -60px;
    width: 44px;
    height: 44px;
  }
`;

export const KelasLiveDownloadBlockTitleStarRightSmallWrapper = styled.span`
  position: absolute;
  top: 5px;
  right: -10px;
  color: ${({ theme }) => theme.colors.brand[400]};
  width: 10px;
  height: 10px;

  @media ${breakpoints.tablet} {
    right: -80px;
    width: 25px;
    height: 25px;
  }
`;
